import DownloadLink from "@/components/ui/download-link";
import Icon from "@/components/ui/icon";
import NoDataRow from "@/components/ui/no-data-row";
import { PresentationProps } from "@/types";
import Table from "react-bootstrap/Table";

export default function PresentationTable({ presentations }: { presentations: PresentationProps[] }) {
  function getMonthYear(timestamp: string): string {
    const date = new Date(timestamp);
    const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short" };
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <Table striped responsive>
      <thead>
        <tr className="g2-table-header-blue">
          <th>Date</th>
          <th>Title</th>
          <th>Studies</th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {presentations.length === 0 && <NoDataRow type="presentations" />}
        {presentations.map((presentation) => (
          <tr key={presentation.id} className="align-middle">
            <td style={{ minWidth: 100 }}>{getMonthYear(presentation.scheduled_at)}</td>
            <td>{presentation.title}</td>
            <td>
              <div className="d-flex flex-wrap">
                {presentation.studies.map((study) => (
                  <span key={study.id} className="g2-badge">
                    {study.title}
                  </span>
                ))}
              </div>
            </td>
            <td className="text-center" style={{ minWidth: 120 }}>
              {presentation.slides && (
                <DownloadLink file={presentation.slides} target="_blank">
                  <Icon icon="file-earmark-slides" me={1} />
                  Slides
                </DownloadLink>
              )}
            </td>
            <td className="text-center" style={{ minWidth: 140 }}>
              {presentation.codebook && (
                <DownloadLink file={presentation.codebook}>
                  <Icon icon="file-earmark-code" me={1} />
                  {presentation.codebook_title || "Stata Code"}
                </DownloadLink>
              )}
            </td>
            <td className="text-center" style={{ minWidth: 120 }}>
              {presentation.video_url && (
                <a className="btn g2-text-blue" href={presentation.video_url} target="_blank">
                  <Icon icon="youtube" me={1} />
                  Video
                </a>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
